/// Valor do filtro para os leads sem responsável. Não é id de usuário.
export const OWNER_UNASSIGNED = 'sem';

/// Nulo passa tudo; OWNER_UNASSIGNED passa só quem não tem dono.
export function matchesOwner(assignedUserId: string | null | undefined, filter: string | null): boolean {
    if (filter === null) return true;

    if (filter === OWNER_UNASSIGNED) return !assignedUserId;

    return assignedUserId === filter;
}
